import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { addOutline, closeCircleOutline, pencilOutline, saveOutline } from 'ionicons/icons';
import InvoiceAmountTable from './InvoiceAmountTable';
import ModalPopup from '@ui/components/VnModal';
import AddInvoiceAmountForm from './AddInvoiceAmountForm';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getAllInvoiceAmountsAsync, updateBulkInvoiceAmountAsync } from '@application/features/invoices/invoiceThunk';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import InvoiceAmountViewTable from './InvoiceAmountViewTable';
import { handleRolePermission } from '@infrastructure/helpers';
import InvoiceAmountViewTableCopiedQuotations from './InvoiceAmountViewTableCopiedQuotations';
import { resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
import { VisserModule } from '@application/common/enums/visser-module';
import { updateModulePermissionsStatusAsync } from '@application/features/workorders/workorderThunk';
const InvoiceAmountTab = ({ isDisabled, formData, handleFieldChange, isInvoiceAmountTabBold }) => {
    const dispatch = useAppDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const { id } = useParams();
    const [isEditing, setIsEditing] = useState(false);
    const [editedData, setEditedData] = useState(null);
    const { InvoiceAmounts } = useAppSelector((state) => state.invoice);
    const { SelectedWorkorderMaterialsList } = useAppSelector((state) => state.material);
    const { SelectedQuotationListForInvoice } = useAppSelector((state) => state.quotation);
    const { WorkOrderNumber } = useAppSelector((state) => state.invoice);
    const onAddAmountClick = () => {
        setIsOpen(true);
    };
    const onAddAmountCloseClicked = () => {
        setIsOpen(false);
    };
    /*Start of Inline Editing Region*/
    useEffect(() => {
        appendDataintoEdit();
    }, [InvoiceAmounts]);
    async function onEdit() {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setIsEditing(true);
        }
    }
    function onSave() {
        if (editedData) {
            const updatedData = editedData.map((item) => ({
                ...item,
                price: item.price === '' ? 0 : item.price,
                quantity: item.quantity === '' ? 0 : item.quantity
            }));
            dispatch(updateBulkInvoiceAmountAsync(updatedData)).then(() => {
                dispatch(getAllInvoiceAmountsAsync(parseInt(id)));
                setIsEditing(false);
                setEditedData(null);
            });
        }
        setIsEditing(false);
    }
    function onCancel() {
        setIsEditing(false);
        appendDataintoEdit();
    }
    function appendDataintoEdit() {
        if (InvoiceAmounts) {
            setEditedData((data) => {
                const updatedData = InvoiceAmounts.map((invoiceAmount) => ({ ...invoiceAmount }));
                return updatedData;
            });
        }
    }
    function onEditData(data) {
        setEditedData(data);
    }
    /*End of Inline Editing Region*/
    const checkModulelock = async () => {
        if (parseInt(id)) {
            dispatch(resetTimer());
            var moduleLockRequestData = {
                moduleId: VisserModule.Facturen,
                recordId: parseInt(id)
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData))
                    .unwrap()
                    .then();
                if (res.isModuleAlreadyLocked) {
                    // setIsPersistantInfoCustomToasterOpen(true);
                    dispatch(setModuleLock());
                    return true;
                }
                else {
                    dispatch(unsetModuleLock());
                    // setIsPersistantInfoCustomToasterOpen(false);
                    return false;
                }
            }
            catch (error) {
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: 'vn-Material-Add-buttons', children: [isEditing && (_jsxs(_Fragment, { children: [_jsx(VnButton, { icon: closeCircleOutline, customClassName: 'vn-action-button vn-inline-editing-action-button', mode: 'danger', size: 'sm', isDisabled: id ? false : true, customIconClassName: 'vn-action-button-icon vn-inline-editing-action-button-icon', onClick: () => {
                                    onCancel();
                                } }), _jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button vn-inline-editing-action-button mr-14', mode: 'primary', size: 'sm', onClick: () => {
                                    onSave();
                                }, type: 'submit', customIconClassName: 'vn-action-button-icon vn-inline-editing-action-button-icon' })] })), !isEditing && InvoiceAmounts && id && (_jsx(VnButton, { icon: pencilOutline, customClassName: 'vn-action-button-cancel vn-inline-editing-action-button mr-14', mode: 'secondary', size: 'sm', customIconClassName: 'vn-action-button-cancel-icon vn-inline-editing-action-button-icon', onClick: () => {
                            onEdit();
                        }, isDisabled: !handleRolePermission(Permission.FACTUREN, PermissionType.Update) || isDisabled })), id && (_jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button mt-1 mb-3', icon: addOutline, 
                        //isDisabled={(id ? false : true) || (isDisabled ? true : false)}
                        isDisabled: handleRolePermission(Permission.FACTUREN, PermissionType.Create) && id && !isDisabled ? false : true, onClick: async () => {
                            var moduleLockStatus = await checkModulelock();
                            if (moduleLockStatus == false) {
                                onAddAmountClick();
                            }
                        }, children: "Regel toevoegen" }))] }), formData.workOrderId && !id
                ? WorkOrderNumber != null
                    ?
                        (_jsx(InvoiceAmountViewTableCopiedQuotations, { handleFieldChange: handleFieldChange, isInvoiceAmountTabBold: isInvoiceAmountTabBold }))
                    :
                        (_jsx(InvoiceAmountViewTable, { formData: formData, handleFieldChange: handleFieldChange, isInvoiceAmountTabBold: isInvoiceAmountTabBold }))
                :
                    (_jsx(InvoiceAmountTable, { isDisabled: isDisabled, isEditing: isEditing, editedData: editedData, editData: onEditData, formData: formData, isInvoiceAmountTabBold: isInvoiceAmountTabBold })), _jsx(ModalPopup, { title: 'Toevoegen Bedrag', content: _jsx(AddInvoiceAmountForm, { onClose: () => onAddAmountCloseClicked(), isDisabled: isDisabled, isInvoiceAmountTabBold: isInvoiceAmountTabBold }), onOpen: isOpen, onClose: () => onAddAmountCloseClicked(), modalWidth: 'lg' })] }));
};
export default InvoiceAmountTab;
